import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY;
export const SUPABASE_BUCKET = process.env.REACT_APP_SUPABASE_BUCKET || 'Transplacement';

if (!SUPABASE_URL || !SUPABASE_KEY) {
  console.warn('[Supabase] Missing REACT_APP_SUPABASE_URL or REACT_APP_SUPABASE_PUBLISHABLE_KEY');
}

export const supabase = createClient(SUPABASE_URL || '', SUPABASE_KEY || '', {
  auth: { persistSession: false, autoRefreshToken: false },
});

export async function uploadOfferLetter(file, userId) {
  const safeUser = (userId || 'anon').replace(/[^a-zA-Z0-9_-]/g, '');
  const stamp = Date.now();
  const rand = Math.random().toString(36).slice(2, 8);
  const path = `${safeUser}/${stamp}_${rand}.pdf`;

  const { error } = await supabase.storage
    .from(SUPABASE_BUCKET)
    .upload(path, file, {
      contentType: 'application/pdf',
      upsert: false,
    });

  if (error) throw error;

  const { data } = supabase.storage.from(SUPABASE_BUCKET).getPublicUrl(path);
  return { path, publicUrl: data.publicUrl };
}
